<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 16/9/2020
  -->

<script>
import {Action} from "@/core/components/Dialogs/DialogActions";
import BaseQwoachDialog from "@/core/components/Dialogs/QwoachDialog/BaseQwoachDialog.vue";
let DeleteConfirmDialog = () => import("@/core/components/Dialogs/QwoachDialog/DeleteConfirmDialog");
import {createDialogLazy} from "@/utils/helpers-external.js";

let deleteConfirmDialog = createDialogLazy(DeleteConfirmDialog)

export default {
	extends: BaseQwoachDialog,
	name: "QwoachDialog",

	methods: {

		async onDelete(){
			let shouldDelete = await this.handleAsync(this.onBeforeDeleteInternal(), this.getDeleteLoadingText())
			console.log("onDelete: shouldDelete = ", shouldDelete)
			if(!shouldDelete){
				return false
			}
			return await this.onAction(Action.DELETE, this.dataItem)
		},

		async onBeforeDeleteInternal(){
			let res = await this.showDeleteConfirmDialog()
			console.log("onBeforeDeleteInternal: res = ", res)
			if(!res){
				return false
			}
			res = await this.onBeforeDelete()
			return res || res === undefined
		},

		async onBeforeDelete(){
		},

		async showDeleteConfirmDialog(){
			return this.showDeleteConfirmDialogStandard()
		},
		async showDeleteConfirmDialogStandard(){
			return await deleteConfirmDialog({
				itemName: this.deletionItemName,
				itemTitle: this.deletionItemTitle,
				confirmActionTitle: this.deleteDialogConfirmActionTitle,
				dialogTitleOverride: this.deleteDialogTitle,
				mainMessage: this.deleteDialogMessage,
				titleCancel: this.deleteDialogButtonCancelTitle,
			})
		},

	},

    computed:{
        deleteDialogConfirmActionTitle(){
            return "Delete"
        },
		deleteDialogTitle() {
			return null
		},
		deleteDialogMessage() {
			return null
		},

        deleteDialogButtonCancelTitle(){
            return "Back"
        },

		itemName(){
			return this.getItemName()
		},

		deletionItemName(){
			return this.itemName
		},

		deletionItemTitle(){
			return null
		}


    }

}
</script>

<style>

</style>
